import React from 'react';
import { ReactComponent as DiscordIcon } from '@assets/svg/discord.svg';
import { ReactComponent as TwitterIcon } from '@assets/svg/twitter.svg';

export const LINKS: string[] = [
    'Terms & Conditions',
    'Privacy Policy',
    'Responsible Gambling',
];

export const SOCIAL_MEDIA: React.ReactNode[] = [
    <DiscordIcon key={0} />,
    <TwitterIcon key={0} />,
];

export const CURRENT_YEAR = new Date().getFullYear();
